var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1210_2139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5V6.119C11.6025 5.715 12 5.028 12 4.25C12 4.184 11.991 4.118 11.974 4.054L11.401 1.941C11.0435 0.78 9.9875 0 8.7725 0H3.227C2.012 0 0.956 0.78 0.5915 1.966L0.026 4.054C0.009 4.118 0 4.184 0 4.25C0 5.0285 0.3975 5.715 1 6.119V9.5C0.4475 9.5 0 9.9475 0 10.5V11.077C0 11.587 0.4135 12 0.923 12H11.077C11.587 12 12 11.5865 12 11.077V10.5C12 9.9475 11.5525 9.5 11 9.5ZM2.032 2.3825C2.1945 1.8545 2.6745 1.5 3.227 1.5H3.5V1.75C3.5 2.1645 3.836 2.5 4.25 2.5C4.664 2.5 5 2.1645 5 1.75V1.5H7V1.75C7 2.1645 7.336 2.5 7.75 2.5C8.164 2.5 8.5 2.1645 8.5 1.75V1.5H8.773C9.325 1.5 9.805 1.8545 9.9605 2.358L10.4955 4.333C10.454 4.7075 10.1355 5 9.75 5H9.25C8.8365 5 8.5 4.6635 8.5 4.25C8.5 3.8365 8.164 3.5 7.75 3.5C7.336 3.5 7 3.8355 7 4.25C7 4.6645 6.6635 5 6.25 5H5.75C5.3365 5 5 4.6635 5 4.25C5 3.8365 4.664 3.5 4.25 3.5C3.836 3.5 3.5 3.8355 3.5 4.25C3.5 4.6645 3.1635 5 2.75 5H2.25C1.8645 5 1.546 4.7075 1.5045 4.333L2.0325 2.383L2.032 2.3825ZM7.3845 10H4.6155L4.154 9.5H2.5V6.5H2.75C3.3285 6.5 3.851 6.2745 4.25 5.915C4.649 6.275 5.1715 6.5 5.75 6.5H6.25C6.8285 6.5 7.351 6.2745 7.75 5.915C8.149 6.275 8.6715 6.5 9.25 6.5H9.5V9.5H7.846L7.3845 10Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1210_2139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.a4dbe081aaec00c1d3c26633d9e8bafc.svg";
export { ForwardRef as ReactComponent };